import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import ModalInvoiceFormatViewModel from "viewModels/products/myProducts/detailPages/optionsDeposit/modalInvoiceFormatViewModel";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form, Modal, Col, Row, Button, LoaderOverlay } from "@emanprague/ppaskit";
import { Check } from "@frui.ts/bootstrap";
import SupplyPointSelectByAccount from "controls/twoway/SupplyPointSelectByAccount";

const modalInvoiceFormatView: ViewComponent<ModalInvoiceFormatViewModel> = observer(({ vm }) => (
  <Modal centered show onHide={vm.requestClose}>
    <Modal.Header closeButton>
      <h2 className="display-4 m-0">{vm.name}</h2>
    </Modal.Header>
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <Modal.Body>
        <Form className="modal-form" onSubmit={preventDefault(vm.confirmChange)}>
          <Form.Row className="form-row-centered">
            <Form.Group as={Row} className="text-center">
              <Check
                target={vm.data}
                property="invoice_short_format"
                label={vm.translate("invoice_short_format")}
                value={true}
                custom
                type="radio"
                inline
                className="mr-4"
              />
              <Check
                target={vm.data}
                property="invoice_short_format"
                label={vm.translate("invoice_standard_format")}
                value={false}
                custom
                type="radio"
                inline
              />
            </Form.Group>
            <SupplyPointSelectByAccount
              defaultSupplyPoints={vm.currentSupplyPointsWithIcons}
              supplyPoints={vm.additionalSupplyPointsWithIcons}
              target={vm.data}
              localization={vm.localization}
              supplyPointErrors={vm.supplyPointsErrors}
              property="supplyPointIds"
            />

            <Form.Group as={Col} xs={12}>
              {vm.errorMessage && <Form.Control.Feedback type="invalid">{vm.errorMessage}</Form.Control.Feedback>}
            </Form.Group>
          </Form.Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="order-2" onClick={vm.confirmChange}>
          {vm.localization.translateGeneral("general.confirm_changes_button")}
        </Button>
        <Button onClick={vm.requestClose} variant="secondary" className="order-1">
          {vm.localization.translateGeneral("general.cancel_button")}
        </Button>
      </Modal.Footer>
    </LoaderOverlay>
  </Modal>
));

registerView(modalInvoiceFormatView, ModalInvoiceFormatViewModel);
